import React, { useState } from 'react';
import Badge from 'react-bootstrap/Badge';
import ReactJsonView from 'react-json-view';
import '../MqttEvent/MqttEvent.css';

function fmtVal(v) {
    if (v === null || v === undefined) return 'null';
    if (typeof v === 'object') return Array.isArray(v) ? '[…]' : '{…}';
    const s = String(v);
    return s.length > 24 ? s.slice(0, 22) + '…' : s;
}

function computeDiffs(value, previousValue) {
    if (!value || !previousValue) return [];
    const keys = new Set([...Object.keys(value), ...Object.keys(previousValue)]);
    const diffs = [];
    for (const key of keys) {
        if (key === '_' || key === '__') continue;
        if (JSON.stringify(value[key]) !== JSON.stringify(previousValue[key])) {
            diffs.push({ key, prev: previousValue[key], curr: value[key] });
        }
    }
    return diffs;
}

function DeviceUpdateEvent({ event }) {
    const [showJson, setShowJson] = useState(false);
    const attrs = event.payload?.attributes || {};
    const {
        field, value, previous_value, value_changed,
        device_name, device_type, bond_id,
    } = attrs;

    const diffs = value_changed ? computeDiffs(value, previous_value) : [];

    return (
        <div style={{ maxWidth: '100%', overflow: 'hidden' }}>

            {/* Row 1: device info */}
            <div className="d-flex align-items-center flex-wrap gap-1 mb-1">
                {device_type && (
                    <Badge bg="secondary" style={{ fontSize: '0.75rem' }}>{device_type}</Badge>
                )}
                {device_name && (
                    <Badge bg="warning" text="dark" style={{ fontSize: '0.75rem' }}>{device_name}</Badge>
                )}
                {field && (
                    <Badge bg="secondary" style={{ fontSize: '0.75rem' }}>{field}</Badge>
                )}
            </div>

            {/* Row 2: {} toggle + diff chips */}
            <div className="d-flex align-items-center flex-wrap gap-1">
                <Badge
                    bg={showJson ? 'secondary' : 'dark'}
                    style={{ cursor: 'pointer', fontSize: '0.75rem', userSelect: 'none', lineHeight: '1.5', padding: '0.35em 0.65em' }}
                    onClick={() => setShowJson(s => !s)}
                    title="Toggle raw JSON"
                >
                    {'{}'}
                </Badge>
                {diffs.map(({ key, prev, curr }) => (
                    <span
                        key={key}
                        style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            fontSize: '0.75rem',
                            backgroundColor: '#f8f9fa',
                            border: '1px solid #dee2e6',
                            borderRadius: '4px',
                            padding: '0.35em 0.65em',
                            fontFamily: 'monospace',
                            gap: '3px',
                        }}
                    >
                        <span style={{ color: '#6c757d' }}>{key}:</span>
                        <span style={{ color: '#dc3545', fontWeight: 600 }}>{fmtVal(prev)}</span>
                        <span style={{ color: '#adb5bd' }}>→</span>
                        <span style={{ color: '#198754', fontWeight: 600 }}>{fmtVal(curr)}</span>
                    </span>
                ))}
            </div>

            {/* Raw JSON */}
            {showJson && (
                <div style={{ marginTop: '6px', maxWidth: '100%', overflowX: 'auto' }}>
                    <ReactJsonView
                        src={event.payload}
                        className="mqttEventPayload"
                        theme="ocean"
                        borderStyle="none"
                        name={false}
                        displayObjectSize={false}
                        displayDataTypes={false}
                        collapsed={2}
                    />
                </div>
            )}
        </div>
    );
}

export default DeviceUpdateEvent;
